import { Grid, Typography } from "@mui/material";

export const SectionMonthlyTraining = () => {
  return (
    <Grid container rowGap={3}>
      <Grid item xs={12}>
        <Typography variant="body2">
          Liebe Patientinnen und Patienten,
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2">
          ein wichtiger und notwendiger Bestandteil für Ihren Ernährungsschein
          ist die Teilnahme an der Ernährungstherapie.
        </Typography>
        <Typography variant="body2" fontWeight="bold">
          Ihre Therapielaufzeit startet mit Teilnahme der ersten
          Ernährungsschulung.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2">
          Sie müssen diese Schulung einmal im Monat besuchen über den Zeitraum
          Ihrer Therapielaufzeit. Das bedeutet:
        </Typography>
        <Typography variant="body2" component="div">
          <ul>
            <li>
              <Typography variant="body2" component="span">
                bei 3 Monaten Therapielaufzeit: mindestens 3 Teilnahmen,
              </Typography>
            </li>
            <li>
              <Typography variant="body2" component="span">
                bei 6 Monaten Therapielaufzeit: mindestens 7 Teilnahmen. Ein
                Starttermin zu Beginn, fünf Zwischentermine verteilt über die 6
                Monate und ein Abschlusstermin, der frühestens nach Ablauf der
                vollen 6 Monate stattfinden darf, keinesfalls früher.
              </Typography>
            </li>
          </ul>
        </Typography>
        <Typography variant="body2">
          Die Länge Ihrer Therapielaufzeit erfahren Sie in Ihrem
          Adipositas-Zentrum.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2">
          Im Idealfall liegen zwischen den Terminen 25-29 Tage.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" fontWeight="bold">
          Wichtig: Der Abstand darf nicht länger als 30 Tage sein – dies sind
          die Anforderungen der Krankenkassen!
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2">
          Sollte Ihr Zeitplan das nicht zulassen, können Sie gerne auch kürzere
          Abstände wählen. Auch dürfen Sie gerne an mehr als den geforderten
          Pflichtschulungen teilnehmen.
        </Typography>
        <Typography variant="body2">
          Wir wissen, dass Sie ganz unterschiedliche Verfügbarkeiten neben Ihrem
          Berufs- und Privatleben haben. Daher bieten wir Ihnen mehrere Termine
          zur Auswahl an.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <iframe
          title="Acuity Scheduling embedded calendar"
          src="https://app.acuityscheduling.com/schedule.php? owner=26947187&appointmentType=53923969"
          width="100%"
          height="800"
        ></iframe>
      </Grid>
    </Grid>
  );
};
